import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useLazyQuery } from '@apollo/client';
import {
  CalenderIcon,
  PricePerUnitIcon,
  TimezoneIcon,
  DiscountIcon,
  QuantityIcon,
} from '../icons/icons';
import PanelCard from '../panel-card/panel-card';
import AdvancePopover from '../advance-popover/advance-popover';
import './time-log.scss';
import UserImage from '../user-image/user-image';
import ListingStatus from '../listing-status/listing-status';
import {
  getUserTimeZoneTiDate,
  getUserTimeZoneTime,
  getUserTimeZoneDateFormat,
} from '../../helpers/dateHelper';
import getInitials from '../../helpers/utils';

import { QUERY_SHOW_TRANSPORTATION_HISTORY } from '../../graphQL/pricingList';

function TimeLog({ data, pricingTransportationId }) {
  const [t] = useTranslation('manageorders');
  const [eventValue, setEventValue] = useState();
  const [apiData, setApiData] = useState([]);
  const [showTransportationHistory] = useLazyQuery(
    QUERY_SHOW_TRANSPORTATION_HISTORY
  );

  const onIconClick = (rowIdTemp) => {
    showTransportationHistory({
      variables: {
        input: { transportationID: rowIdTemp },
      },
      onCompleted: (res) => {
        const history =
          res?.showTransportationHistory?.data?.statusHistory || [];

        const groupedByDay = Object.values(
          history.reduce((acc, entry) => {
            // Take only the YYYY-MM-DD portion to group by date:
            const dayKey = entry?.createdAt?.split('T')[0];

            // If this is the first time we see this day, initialize:
            if (!acc[dayKey]) {
              acc[dayKey] = {
                // Use the first entry’s full timestamp for createdAt
                createdAt: entry?.createdAt,
                changeLog: [{ reasonLog: [] }],
              };
            }

            // Split the name into first/last
            const [firstName = '', ...rest] = entry.statusByName.split(' ');
            const lastName = rest.join(' ');

            // Build the log record
            const reasonRecord = {
              parameter: entry?.statusName ?? '',
              currentStatus: entry?.statusName ?? '',
              createdAt: entry?.statusDate ?? '',
              userData: { createdBy: { firstName, lastName } },
              note: entry?.note ?? '',
            };

            // Push into that day’s reasonLog
            acc[dayKey]?.changeLog[0]?.reasonLog?.push(reasonRecord);

            return acc;
          }, {})
        );

        setApiData(groupedByDay);
      },
    });
  };
  const togglePopover = async (e) => {
    await setEventValue(e.target);
    if (pricingTransportationId && pricingTransportationId !== '') {
      onIconClick(pricingTransportationId);
    }
  };

  const handleClose = () => {
    setEventValue(null);
  };
  return (
    <div className="time-log">
      <button
        type="button"
        className="log-button"
        onClick={togglePopover}
        id="dateHistoryPopover"
        disabled={data.length}
      >
        <TimezoneIcon color="#45B4D0" />
      </button>

      <AdvancePopover
        reference="dateHistoryPopover"
        getEvent={eventValue}
        closePopover={handleClose}
        placement="left"
      >
        <div className="time-log-logs">
          <PanelCard cardTitle={t('manageordersscreen.order.changetimeline')}>
            <div className="time-log-pop">
              {apiData.length > 0
                ? apiData?.map((value) => {
                    return (
                      <ul className="time-log-list">
                        <span className="date-group">
                          {value.updatedAt
                            ? getUserTimeZoneTiDate(value?.updatedAt)
                            : getUserTimeZoneTiDate(value?.createdAt)}
                        </span>
                        {value &&
                          value?.changeLog?.map((val) => {
                            return (
                              <div className="reason-block">
                                {val?.reason && (
                                  <p className="reason">
                                    <span>
                                      {t('manageordersscreen.order.reason')}-
                                    </span>{' '}
                                    {val?.reason}
                                  </p>
                                )}
                                {val?.reasonLog?.map((va) => {
                                  return (
                                    <li>
                                      <span className="circle">
                                        {va?.parameter === 'Rate Requested' && (
                                          <CalenderIcon color="#ffffff" />
                                        )}

                                        {va?.parameter === 'Rate Entered' && (
                                          <PricePerUnitIcon />
                                        )}
                                        {va?.parameter === 'Sent to Sales' && (
                                          <DiscountIcon />
                                        )}
                                        {(va?.parameter === 'Accepted' ||
                                          va?.parameter === 'Rejected') && (
                                          <QuantityIcon />
                                        )}
                                      </span>
                                      <div className="details">
                                        <div className="description">
                                          <UserImage
                                            name={`${va?.userData?.createdBy?.firstName} ${va?.userData?.createdBy?.lastName}`}
                                            path={
                                              value?.userData?.createdBy
                                                ?.profilePicture
                                            }
                                            removeTooltip
                                            type="square"
                                            shortName={getInitials(
                                              `${va?.userData?.createdBy?.firstName} ${va?.userData?.createdBy?.lastName}`
                                            )}
                                          />
                                          <div className="info">
                                            <p className="msg-description">
                                              {t(
                                                `manageordersscreen.filterbtn.secredOptions.${va?.parameter}`
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                        <p className="text">
                                          {t('manageordersscreen.order.by')}{' '}
                                          {`${va?.userData?.createdBy?.firstName} ${va?.userData?.createdBy?.lastName}`}
                                          ,{' '}
                                          <span>
                                            {t('manageordersscreen.order.at')}{' '}
                                            {getUserTimeZoneTime(va?.createdAt)}
                                          </span>
                                        </p>
                                        {va?.note && (
                                          <p className="text">
                                            <span>{va?.note}</span>
                                          </p>
                                        )}
                                      </div>
                                      <div className="status">
                                        <ListingStatus
                                          statusLabel={va?.currentStatus}
                                        />
                                      </div>
                                    </li>
                                  );
                                })}
                              </div>
                            );
                          })}
                      </ul>
                    );
                  })
                : data?.map((value) => {
                    return (
                      <ul className="time-log-list">
                        <span className="date-group">
                          {value.updatedAt
                            ? getUserTimeZoneTiDate(value.updatedAt)
                            : getUserTimeZoneTiDate(value.createdAt)}
                        </span>
                        {value &&
                          value?.changeLog?.map((val) => {
                            return (
                              <div className="reason-block">
                                {val?.reason && (
                                  <p className="reason">
                                    <span>
                                      {t('manageordersscreen.order.reason')}-
                                    </span>{' '}
                                    {val?.reason}
                                  </p>
                                )}
                                {val?.reasonLog?.map((va) => {
                                  return (
                                    <li>
                                      <span className="circle">
                                        {va?.parameter ===
                                          'Due date change' && (
                                          <CalenderIcon color="#ffffff" />
                                        )}

                                        {(va?.parameter ===
                                          'Price per unit change' ||
                                          va?.parameter ===
                                            'Total price change') && (
                                          <PricePerUnitIcon />
                                        )}
                                        {va?.parameter ===
                                          'Discount change' && <DiscountIcon />}
                                        {va?.parameter ===
                                          'Quantity change' && <QuantityIcon />}
                                      </span>
                                      <div className="details">
                                        <div className="description">
                                          <UserImage
                                            name={`${value?.userData?.createdBy?.firstName} ${value?.userData?.createdBy?.lastName}`}
                                            path={
                                              value?.userData?.createdBy
                                                ?.profilePicture
                                            }
                                            removeTooltip
                                            type="square"
                                            shortName={getInitials(
                                              `${value?.userData?.createdBy?.firstName} ${value?.userData?.createdBy?.lastName}`
                                            )}
                                          />
                                          <div className="info">
                                            <p className="msg-description">
                                              {t(
                                                `manageordersscreen.order.${va.parameter}`
                                              )}
                                              <span>
                                                {va?.parameter ===
                                                'Due date change'
                                                  ? getUserTimeZoneDateFormat(
                                                      va?.oldData
                                                    )
                                                  : va?.oldData}
                                                {va?.parameter ===
                                                  'Price per unit change' ||
                                                va?.parameter ===
                                                  'Total price change'
                                                  ? '$'
                                                  : ''}
                                                {va?.parameter ===
                                                'Discount change'
                                                  ? '%'
                                                  : ''}{' '}
                                                {t(
                                                  'manageordersscreen.order.to'
                                                )}{' '}
                                                {va?.parameter ===
                                                'Due date change'
                                                  ? getUserTimeZoneDateFormat(
                                                      va?.newData
                                                    )
                                                  : va?.newData}
                                                {va?.parameter ===
                                                  'Price per unit change' ||
                                                va?.parameter ===
                                                  'Total price change'
                                                  ? '$'
                                                  : ''}
                                                {va?.parameter ===
                                                'Discount change'
                                                  ? '%'
                                                  : ''}
                                              </span>
                                            </p>
                                          </div>
                                        </div>
                                        <p className="text">
                                          {t('manageordersscreen.order.by')}{' '}
                                          {`${value?.userData?.createdBy?.firstName} ${value?.userData?.createdBy?.lastName}`}
                                          ,{' '}
                                          <span>
                                            {t('manageordersscreen.order.at')}{' '}
                                            {getUserTimeZoneTime(va?.createdAt)}
                                          </span>
                                        </p>
                                      </div>
                                      <div className="status">
                                        <ListingStatus
                                          statusLabel={va?.currentStatus}
                                        />
                                      </div>
                                    </li>
                                  );
                                })}
                              </div>
                            );
                          })}
                      </ul>
                    );
                  })}
            </div>
            {/* );
            })} */}
          </PanelCard>
        </div>
      </AdvancePopover>
    </div>
  );
}

export default TimeLog;
TimeLog.propTypes = {
  data: PropTypes.arrayOf(Object),
  pricingTransportationId: PropTypes.string,
};
TimeLog.defaultProps = {
  data: [],
  pricingTransportationId: '',
};
